export function isEscapeKey(ev: KeyboardEvent) {
    let isEsc = false;
    if (ev.key == "Escape" || ev.key == "Esc" || ev.keyCode == 27) {
        isEsc = true;
    }
    return isEsc;
}